import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'fl-story-header',
  template: `
    <h2 class="text-body-24 font-normal mb-xxsmall">
      <ng-content></ng-content>
    </h2>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StoryHeaderComponent {}
